/* @flow */
import * as React from 'react';

//----------------------------------------------------------------------//
// CSS                                                                  //
//----------------------------------------------------------------------//

import styles from './AutoWrapper.module.scss';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

export type TypeProps = {|
  children: React.Node,
|};

function AutoWrapper(props: TypeProps): React.Component<*> {
  return <div className={styles['auto-wrapper']}>{props.children}</div>;
}

export default AutoWrapper;
